import React from 'react';
import { useLiveClock } from '../hooks/useLiveClock';
import { useWeather } from '../hooks/useWeather';
import { describeWeather } from '../utils/weather';
type VisitorInfoBarProps = {
  city: string | null;
  timezone: string | null;
  latitude: number | null;
  longitude: number | null;
};
export function VisitorInfoBar({
  city,
  timezone,
  latitude,
  longitude
}: VisitorInfoBarProps) {
  const time = useLiveClock(timezone);
  const weather = useWeather(latitude, longitude);
  const description = weather ? describeWeather(weather.code, weather.isDay) : null;
  return <p className="mt-1 flex flex-wrap items-center gap-x-2.5 gap-y-1 font-sans text-[0.8rem] text-ink-soft" data-id="element-227" data-mp="3m9kkaqkzi4oy">
      <span className="whitespace-nowrap" data-id="element-228" data-mp="3db7iwzio4h56">
        🕒 Hora local: <time className="tabular-nums font-medium text-ink" data-id="element-229" data-mp="3dbqxc6940neg">{time}</time>
      </span>
      {weather && description && <>
          <span aria-hidden="true" className="text-ink-muted" data-id="element-230" data-mp="1bjucg611y170">
            |
          </span>
          <span className="whitespace-nowrap" data-id="element-231" data-mp="1bhhv9v34buv0">
            <span aria-hidden="true" data-id="element-232" data-mp="6xhyq8ttj56q">{description.emoji}</span>{' '}
            {city ? `${city}: ` : ''}
            <span className="font-medium text-ink" data-id="element-233" data-mp="1ynhvcfevqp9">{weather.temperature}°C</span>, {description.label.toLowerCase()}
          </span>
        </>}
    </p>;
}